import { StyleSheet } from 'react-native';

import {
  buttonProportionsLarge,
  extraSmallMarginHorizontalBox,
  centeredBox,
} from '../view-style';

export default StyleSheet.create({
  container: {
    borderRadius: 50,
    ...buttonProportionsLarge,
    ...centeredBox,
    ...extraSmallMarginHorizontalBox,
  },
  view: {
    flexDirection: 'row',
    ...centeredBox,
  },
  recordContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorContainer: {
    marginTop: 12,
    alignItems: 'center',
  },
  errorDescription: {
    textAlign: 'center',
    paddingHorizontal: 12,
    paddingTop: 4,
  },
});
